var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19936_13139)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_19936_13139)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75 0H4.58333C2.05 0 0 2.05 0 4.58333V30.4167C0 32.95 2.05 35 4.58333 35H15.5667C14.6667 33.1 14.1667 30.9833 14.1667 28.75C14.1667 26.8333 14.5333 25 15.2333 23.3167C15.5667 22.4667 15.9833 21.65 16.4667 20.9C17.55 19.2167 18.95 17.7833 20.6 16.6667C21.45 16.0833 22.35 15.6 23.3167 15.2333C24.8667 14.5833 26.5667 14.2167 28.3333 14.1833V4.58333C28.3333 2.05 26.2833 0 23.75 0Z",
    fill: "#E4E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 15C23.3333 15.0834 23.3333 15.1667 23.3167 15.2334C22.35 15.6 21.45 16.0834 20.6 16.6667H6.66667C5.75 16.6667 5 15.9167 5 15C5 14.0834 5.75 13.3334 6.66667 13.3334H21.6667C22.5833 13.3334 23.3333 14.0834 23.3333 15Z",
    fill: "#9AA2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4667 20.9C15.9833 21.65 15.5667 22.4667 15.2333 23.3167C15.1667 23.3333 15.0833 23.3333 15 23.3333H6.66667C5.75 23.3333 5 22.5833 5 21.6667C5 20.75 5.75 20 6.66667 20H15C15.6333 20 16.2 20.3667 16.4667 20.9Z",
    fill: "#9AA2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10H6.66667C5.74667 10 5 9.25335 5 8.33335C5 7.41335 5.74667 6.66669 6.66667 6.66669H13.3333C14.2533 6.66669 15 7.41335 15 8.33335C15 9.25335 14.2533 10 13.3333 10Z",
    fill: "#9AA2AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 40C22.5467 40 17.5 34.9533 17.5 28.75C17.5 22.5467 22.5467 17.5 28.75 17.5C34.9533 17.5 40 22.5467 40 28.75C40 34.9533 34.9533 40 28.75 40Z",
    fill: "#2D87F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.75 35C27.83 35 27.0834 34.2533 27.0834 33.3333V24.1667C27.0834 23.2467 27.83 22.5 28.75 22.5C29.67 22.5 30.4167 23.2467 30.4167 24.1667V33.3333C30.4167 34.2533 29.67 35 28.75 35Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 30.4166H24.1667C23.2467 30.4166 22.5 29.67 22.5 28.75C22.5 27.83 23.2467 27.0833 24.1667 27.0833H33.3333C34.2533 27.0833 35 27.83 35 28.75C35 29.67 34.2533 30.4166 33.3333 30.4166Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19936_13139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_19936_13139"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSvg);
export default __webpack_public_path__ + "static/media/DocumentSvg.c41d87e01b1c3c2cbe3c2fca104404a8.svg";
export { ForwardRef as ReactComponent };